import { debug } from "../common";
import { InputElement } from "./InputElement";
/**
 * Input Range Element
 */
export class InputRangeElement extends InputElement {
    /**
     * Constructor
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    constructor(htmlElement, bindData, context) {
        super(htmlElement, bindData, context);
        this.trueValue = true;
        this.falseValue = false;
    }
    /**
     * Sets readonly
     * @param readonly readonly or not
     */
    setReadonly(readonly) {
        debug('InputRangeElement.setReadonly', readonly);
        this.getHtmlElement().readOnly = readonly;
        if (readonly) {
            this.getHtmlElement().addEventListener('mousedown', this.disableEvent);
            this.getHtmlElement().addEventListener('touchstart', this.disableEvent);
        }
        else {
            this.getHtmlElement().removeEventListener('mousedown', this.disableEvent);
            this.getHtmlElement().removeEventListener('touchstart', this.disableEvent);
        }
    }
    /**
     * Disable event
     * @param event event
     */
    disableEvent(event) {
        event.preventDefault();
        return false;
    }
}
//# sourceMappingURL=InputRangeElement.js.map